import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import axios from "axios";
import MonthlyCalenderTable from "./MonthlyCalenderTable";
import useCommonApi from "../hooks/common-apis";
import { socketService } from "./socketService";
import { clog } from "../lib/utils";

function MonthlyCalenderComponent({}) {
  const navigate = useNavigate();
  const { getAgentsData } = useCommonApi();
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month()); // 0-indexed
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [monthlyData, setmonthlyData] = useState([]);
  const [monthlyDataEdit, setmonthlyDataEdit] = useState([]);
  const [loadingMonthlyData, setloadingMonthlyData] = useState(false);
  const [generatingMonthlyData, setgeneratingMonthlyData] = useState(false);
  const [monthlyDataError, setmonthlyDataError] = useState("");
  const [savingTitle, setsavingTitle] = useState("");
  const [changingStatus, setchangingStatus] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [approvingTitle, setapprovingTitle] = useState(false);
  const [getAgentData, setgetAgentData] = useState(false);
  const [agentData, setagentData] = useState([]);
  const [assigningTitle, setassigningTitle] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const assignEmployeeToTask = async () => {
    setassigningTitle(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/assign_employee`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          month: (selectedMonth + 1)?.toString()?.padStart(2, "0"),
          year: selectedYear?.toString(),
          employee_id: selectedEmployee,
          calendar_ids: selectedRows,
        },
      });
      if (!response.data.error) {
        notify(response.data?.message, "success");
        setSelectedRows([]);
        setSelectedEmployee("");
        getMonthlyCalenderData();
      } else {
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setassigningTitle(false);
    }
  };
  const notify = (message, type) =>
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type,
    });
  const getAgentsDataFn = async () => {
    setgetAgentData(true);
    try {
      let response = await getAgentsData();
      if (!response.data.error) {
        setagentData(response?.data || []);
      } else {
        clog("Error in fetching notifications");
        setagentData([]);
      }
    } catch (error) {
    } finally {
      setgetAgentData(false);
    }
  };
  const generateMonthlyCalenderData = async (code) => {
    setgeneratingMonthlyData(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/content_calendar`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {},
      });
      if (!response.data.error) {
        setmonthlyData(response.data?.data || []);
        setmonthlyDataEdit(response.data?.data || []);
        notify(response.data?.message, "success");
        getMonthlyCalenderData();
      } else {
        setmonthlyData([]);
        setmonthlyDataEdit([]);
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      setmonthlyData([]);
      setmonthlyDataEdit([]);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setgeneratingMonthlyData(false);
    }
  };
  const [eventinprocess, seteventinprocess] = useState(null);
  const getMonthlyCalenderData = async (code) => {
    if (!localStorage.getItem("google_search_console_access")) {
      return;
    }
    setloadingMonthlyData(true);
    let data = {
      month: (selectedMonth + 1)?.toString()?.padStart(2, "0"),
      year: selectedYear?.toString(),
    };
    if (pathname?.includes("ai-employee")) {
      data["emp_id"] = JSON.parse(localStorage.getItem("selected_agent"))?.id;
    }

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/calendar_list`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        let data = response.data?.data || [];
        let approvedIds = [];
        data?.forEach((item) => {
          if (item?.status && item?.status >= 2) {
            approvedIds.push(item?._id);
          }
        });
        setSelectedRows(approvedIds);
        setmonthlyData(data);
        setmonthlyDataEdit(data);
        seteventinprocess(response?.data?.eventinprocess || null);
      } else {
        setmonthlyData([]);
        setmonthlyDataError(response?.data?.message);
      }
    } catch (error) {
      clog(error);
      setmonthlyData([]);
      setmonthlyDataError(error?.response?.data?.message || error?.message);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloadingMonthlyData(false);
    }
  };
  const saveMonthlyCalenderDataTitle = async (data, update) => {
    setsavingTitle(data?.id);
    if (update === "status") {
      setchangingStatus(data?.id);
    }
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/calendar_update`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        notify(response.data?.message, "success");
        setmonthlyData((prev) =>
          prev?.map((item) => {
            if (item._id === data?.id) {
              return {
                ...item,
                title: update === "title" ? data?.title : item?.title,
                suggested_keywords:
                  update === "keywords"
                    ? data?.suggested_keywords
                    : item?.suggested_keywords,
                status: update === "status" ? data?.status : item?.status,
              };
            }
            return item;
          })
        );
        setmonthlyDataEdit((prev) =>
          prev?.map((item) => {
            if (item._id === data?.id) {
              return {
                ...item,
                edit: false,
              };
            }
            return item;
          })
        );
      } else {
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setsavingTitle("");
      setchangingStatus("");
    }
  };
  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    // You can fetch monthlyData here based on selected month
  };
  const handleYearChange = (value) => {
    if (selectedMonth > currentMonth && value === currentYear) {
      setSelectedMonth(currentMonth);
    }
    setSelectedYear(value);
    // Same: fetch/filter based on year if needed
  };
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month(); // 0-indexed (January = 0)

  const monthOptions = dayjs.months().map((month, index) => ({
    label: month,
    value: index,
    disabled: selectedYear === currentYear && index > currentMonth, // disable future months
  }));
  const yearOptions = Array.from({ length: 5 }, (_, i) => {
    const year = currentYear - 4 + i;
    return { label: year.toString(), value: year };
  });
  const approvedId = monthlyData?.map((item) => {
    if (item?.status && item?.status >= 2) {
      return item?._id;
    }
  });
  const approvedIdSet = new Set(approvedId);

  let idsNotInApproved = selectedRows.filter((id) => !approvedIdSet.has(id));
  clog(idsNotInApproved, "idsNotInApproved");
  // check if any monthlyDataEdit has edit key is true;
  let hasEdit = monthlyDataEdit?.some((item) => item?.edit === true);
  const approveMonthlyCalenderData = async () => {
    if (idsNotInApproved?.length === 0 || !selectedEmployee) {
      return;
    }
    setapprovingTitle(true);
    let data = {
      emp_id: selectedEmployee,
      updata: idsNotInApproved,
    };
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/calendar_approved`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        notify(response.data?.message, "success");
        setSelectedRows([]);
        getMonthlyCalenderData();
      } else {
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setapprovingTitle(false);
    }
  };
  const getButtonText = () => {
    if (
      selectedRows?.length > 0 &&
      selectedRows?.length === monthlyData?.length
    ) {
      return "Assign & Approve All";
    } else {
      return "Assign & Approve";
    }
  };
  const disableAllactionsForYear = () => {
    // Except for current month and year all previous months and years should be disabled
    if (selectedYear === currentYear && selectedMonth === currentMonth) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (localStorage.getItem("google_search_console_access")) {
      getMonthlyCalenderData();
    }
  }, [selectedMonth, selectedYear]);
  const pathname = window?.location?.pathname;
  useEffect(() => {
    if (pathname?.includes("monthly-calendar")) {
      getAgentsDataFn();
    }
  }, [pathname]);
  useEffect(() => {
    if (!localStorage.getItem("google_search_console_access")) {
      return;
    }
    if (pathname?.includes("ai-employee")) {
      return;
    }
    if (!socketService.isConnected()) {
      socketService.initialize();
    }
    const handleMonthlyNotification = (data) => {
      clog("Monthly data:", data);
      if (data?.contents) {
        getMonthlyCalenderData();
      }
    };

    socketService.on("monthlycalendar_notification", handleMonthlyNotification);

    return () => {
      socketService.off(
        "monthlycalendar_notification",
        handleMonthlyNotification
      );
    };
  }, [pathname]);
  return (
    <>
      {!localStorage.getItem("google_search_console_access") ? (
        <>
          <div className="text-center">
            <h2 className="pb-4 text-[24px] font-[700]">
              To get the monthly calender please connect to webmaster
            </h2>
            <button
              className="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-[#fff] h-[40px] w-[200px] rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500]"
              onClick={() => navigate("/integration-marketing")}
            >
              Connect
            </button>
          </div>
        </>
      ) : (
        <div>
          <div className="flex items-center justify-between">
            <h4 className="text-[24px] font-[700] flex gap-1 items-center mb-2">
              Proposed{" "}
              <Select
                value={selectedMonth}
                options={monthOptions}
                onChange={handleMonthChange}
                bordered={false}
                className="custom-dropdown !w-fit !text-[24px]"
                dropdownStyle={{ zIndex: 9999, width: "100px" }}
              />{" "}
              <Select
                value={selectedYear}
                options={yearOptions}
                onChange={handleYearChange}
                bordered={false}
                className="custom-dropdown !w-fit !text-[24px]"
                dropdownStyle={{ zIndex: 9999 }}
              />
              Month Calendar
            </h4>
            {!loadingMonthlyData &&
              monthlyData?.length > 0 &&
              pathname.includes("monthly-calendar") && (
                <>
                  <div className="flex gap-2">
                    {/* Employee Dropdown */}
                    <select
                      className="py-1 px-3 rounded-full text-[18px] font-semibold ring-inset bg-white focus:outline-none disabled:opacity-70"
                      value={selectedEmployee}
                      onChange={(e) => setSelectedEmployee(e.target.value)}
                      disabled={
                        disableAllactionsForYear() ||
                        selectedRows?.length === 0 ||
                        idsNotInApproved?.length === 0 ||
                        approvingTitle
                      }
                    >
                      <option value="">Choose Employee</option>
                      {agentData?.map((emp) => (
                        <option key={emp?.id} value={emp?.id}>
                          {emp.emp_name}
                        </option>
                      ))}
                    </select>

                    {/* Approve Button */}
                    <button
                      type="submit"
                      className="py-1 px-3 rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 disabled:opacity-50"
                      disabled={
                        !selectedEmployee ||
                        disableAllactionsForYear() ||
                        selectedRows?.length === 0 ||
                        idsNotInApproved?.length === 0 ||
                        approvingTitle
                      }
                      onClick={() => {
                        approveMonthlyCalenderData();
                      }}
                    >
                      {approvingTitle ? <Loader /> : getButtonText()}
                    </button>
                  </div>
                </>
              )}
          </div>
          {loadingMonthlyData && (
            <div className="w-full h-full flex justify-center items-center">
              <Loader />
            </div>
          )}
          {!loadingMonthlyData && monthlyData?.length === 0 && (
            <div className="text-center">
              {disableAllactionsForYear() ? (
                <>
                  <h2 className="pb-4 text-[24px] font-[700]">
                    No data available for this month
                  </h2>
                </>
              ) : (
                <>
                  {pathname?.includes("ai-employee") && (
                    <h3 className="pt-6 pb-2 text-[22px] font-[600]">
                      Assign tasks to{" "}
                      {
                        JSON.parse(localStorage.getItem("selected_agent"))
                          ?.emp_name
                      }{" "}
                      from the Monthly Calendar.
                    </h3>
                  )}
                  <button
                    className="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-[#fff] h-[40px] w-[200px] rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500] flex mx-auto justify-center items-center"
                    onClick={() => {
                      if (pathname?.includes("ai-employee")) {
                        navigate("/monthly-calendar");
                        return;
                      }
                      if (eventinprocess) {
                        notify(
                          "Your Monthly Calendar is already in process. Please check after some time!",
                          "info"
                        );
                        return;
                      }
                      generateMonthlyCalenderData();
                    }}
                  >
                    {generatingMonthlyData ? (
                      <Loader />
                    ) : (
                      <>
                        {pathname?.includes("ai-employee") ? (
                          <>
                            Go To Calendar{" "}
                            <span>
                              <svg className="icon text-[20px] ml-2">
                                <use href="#icon_rightarrow"></use>
                              </svg>
                            </span>
                          </>
                        ) : (
                          "Generate"
                        )}
                      </>
                    )}
                  </button>
                </>
              )}
            </div>
          )}
          {!loadingMonthlyData && monthlyData?.length > 0 && (
            <div>
              <MonthlyCalenderTable
                monthlyData={monthlyData}
                setmonthlyData={setmonthlyData}
                monthlyDataEdit={monthlyDataEdit}
                setmonthlyDataEdit={setmonthlyDataEdit}
                loadingMonthlyData={loadingMonthlyData}
                monthlyDataError={monthlyDataError}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                saveMonthlyCalenderDataTitle={saveMonthlyCalenderDataTitle}
                savingTitle={savingTitle}
                setsavingTitle={setsavingTitle}
                changingStatus={changingStatus}
                setchangingStatus={setchangingStatus}
                disableAllactionsForYear={disableAllactionsForYear}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default MonthlyCalenderComponent;
